import React, { Component } from 'react';
import { Menu, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { signOut } from '../../store/actions/authActions';

import Brand from '../../resources/logo.png';

class MainNav extends Component {
  state = {
    activeID: 'home'
  }

  componentDidMount(){
    const { activeID } = this.props.mainNavConfig;
    this.setState({activeID})
  }
  

  handleItemClick = (e, { id }) => {
    this.setState({ activeID: id });
  }

  handleSignOut = () => {
    this.props.signOut();
  }


  render() {

    const { activeID } = this.state;
    const { links } = this.props.mainNavConfig;
    return (
      <div>
        <Menu style={{ padding: '0px 30px' }}>
          <Menu.Item header>
            <Image src={Brand ? Brand : 'Brand'} size='small' />
          </Menu.Item>

          <Menu.Item header>
            <p>Hik-Portal<br />Managment Console</p>
          </Menu.Item>

          {
            // Takes in main navigation configuration passed as a property and generate menu items
            links ?
            links.map((navItem) => {
                return (
                  <Menu.Item
                    onClick={this.handleItemClick}
                    name={navItem.name}
                    id={navItem.id}
                    key={navItem.link}
                    active={activeID === navItem.id}
                    as={Link}
                    to={navItem.link}
                  />
                )
              })
              :
              null
          }


          <Menu.Menu position='right'>
            <Menu.Item
              name='logout'
              active={activeID === 'logout'}
              onClick={this.handleSignOut}
            />
          </Menu.Menu>
        </Menu>

      </div>
    )
  }
}



const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut())
  }
}

const mapStateToProps = (state) => {
  return {
    accessRole: state.firestore.data.accessRole
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainNav);